export default __webpack_public_path__ + "static/media/tv_amazon.de36b2f2.svg";